import type { Client, RequestContext } from "../client";
import type { UserRoleResource } from "../resources/userRoleResource";
import type { ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";

export type UserRoleListArgs = ListArgs & {
    partialName?: string;
};

export class UserRoleRepository extends BasicRepository<UserRoleResource, UserRoleResource, UserRoleListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("UserRoles", client, requestContext);
    }
}
